/**
 * Shared query hook for tenant-wide open corrective-action counts.
 *
 * Lives here (with the other widget hooks) so both the Home delivery summary
 * card and any other widget import it from a shared location: the widget
 * must not reach up into a page module for its data (inverted layering).
 */ import { useQuery } from '@tanstack/react-query';
import { deliveryClient } from '../../../lib/connect/clients';
export const OPEN_CORRECTIVE_ACTIONS_KEY = 'open-corrective-actions';
export function useOpenCorrectiveActions({ companyId, enabled = true }) {
    return useQuery({
        queryKey: [
            OPEN_CORRECTIVE_ACTIONS_KEY,
            companyId
        ],
        queryFn: async ()=>deliveryClient.getOpenCorrectiveActionCounts({
                companyId
            }),
        enabled,
        staleTime: 30000
    });
}
